import { lazy, Suspense, useEffect } from 'react';

import { Container } from '@mui/material';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { flowRight as compose, isEmpty } from 'lodash';
import { inject, observer } from 'mobx-react';
import { Route, Routes } from 'react-router-dom';

import Loading from 'components/Loading';
import acl from 'constants/acl';
import { ProtectedRoute } from 'providers';
import VehicleScreen from 'screens/VehicleScreen';
import { lightTheme } from 'themes';
import Header from './Header';
import Navigation from './Navigation';
import Payment from './Payment';
import Account from './account';
import DispatchScreen from './dispatch';
import DriverList from './drivers';

const UserScreen = lazy(() => import('./Users'));

function AppContainer(props) {
  const { store } = props;
  const { userStore, permissionStore } = store;
  const { user } = userStore;
  const { permissionLoaded } = permissionStore;

  useEffect(() => {
    userStore.getUser();
    userStore.getDsp();
  }, [userStore]);

  if (isEmpty(user) || !permissionLoaded) return <Loading />;

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={lightTheme}>
        <Container disableGutters maxWidth={false}>
          <Header />
          <Navigation />
        </Container>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
                <Route
                  path="/vehicles/*"
                  element={
                    <ProtectedRoute deniedPatterns={acl.VEHICLES.LIST}>
                      <VehicleScreen />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/drivers/*"
                  element={
                    <ProtectedRoute deniedPatterns={acl.DRIVERS.LIST}>
                      <DriverList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/profile/*"
                  element={
                    <ProtectedRoute>
                      <Account />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/payments/*"
                  element={
                    <ProtectedRoute deniedPatterns={[...acl.PAYMENTS.EVENT_LIST, ...acl.PAYMENTS.TRANSACTION_LIST]}>
                      <Payment />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/routes/:day/:region/:assignmentId/*"
                  element={
                    <ProtectedRoute deniedPatterns={acl.ASSIGNMENTS.LIST}>
                      <DispatchScreen />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/routes/:day/:region/*"
                  element={
                    <ProtectedRoute deniedPatterns={acl.ASSIGNMENTS.LIST}>
                      <DispatchScreen />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/routes/:day/*"
                  element={
                    <ProtectedRoute deniedPatterns={acl.ASSIGNMENTS.LIST}>
                      <DispatchScreen />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/routes/*"
                  element={
                    <ProtectedRoute deniedPatterns={acl.ASSIGNMENTS.LIST}>
                      <DispatchScreen />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/users/*"
                  element={
                    <ProtectedRoute deniedPatterns={acl.USERS.USER_LIST}>
                      <UserScreen />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/*"
                  element={
                    <ProtectedRoute deniedPatterns={acl.ASSIGNMENTS.LIST}>
                      <DispatchScreen />
                    </ProtectedRoute>
                  }
                />
            </Routes>
          </Suspense>
        </ThemeProvider>
      </StyledEngineProvider>
  );
}

export default compose(inject('store'), observer)(AppContainer);
